import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    input: {
      // hide mic by default
      "& .mic-icon": {
        display: "none",
        opacity: 0,
        transition: "opacity 0.2s ease",
        // pointerEvents: "none",
      },

      // show mic when focused
      "&:hover .mic-icon, &:focus-within .mic-icon": {
        display: "flex",
        opacity: 1,
        // pointerEvents: "auto",
      },
    },
  })
);
